import { TestPage } from "@/pages/TestPage";
import * as Sentry from "@sentry/react";
import { BrowserRouter, useRoutes } from "react-router-dom";

const useSentryRoutes = Sentry.wrapUseRoutes(useRoutes);

const Routes = () => {
	const commonRoutes = [{ path: "/", element: <TestPage /> }];

	const routes = useSentryRoutes([...commonRoutes]);
	return routes;
};

export const AppRoutes = () => {
	return (
		<BrowserRouter>
			<Routes />
		</BrowserRouter>
	);
};
